import * as FieldType from "../constants/FieldType";
import {renderField} from "../widgets/FieldWidgetCreator";
import * as Formats from "../constants/Formats";
import moment from "moment/moment";
import * as CommonConstants from "../constants/CommonConstants";
import {areEqual, isNullOrUndefined} from "./NamaCommon";

let fiscalPeriod = {};
export function createFieldMetadata(filterField) {
    if (!filterField)
        return null;
    if (filterField.hijri === true)
        filterField.metaData.hijri = filterField.hijri;
    if (filterField.list === true)
        filterField.metaData.list = filterField.list;
    let fieldMetadata = filterField.metaData;
    fieldMetadata.fieldId = filterField.id;
    fieldMetadata.markForCriteria = true;
    if (filterField.allowedValues) {
        fieldMetadata.allowedValues = [];
        for (let allowedValue of filterField.allowedValues)
            fieldMetadata.allowedValues.push(allowedValue.id);
    }
    if (filterField.enumTypeName)
        fieldMetadata.enumTypeName = filterField.enumTypeName;
    fieldMetadata.hijri = filterField.hijri;
    fieldMetadata.defaultEntityType = filterField.defaultEntityType;
    fieldMetadata.required = filterField.required;
    return fieldMetadata;
}
export function getRightHandSideWidget(filterField, editor) {
    let fieldMetadata = createFieldMetadata(filterField);

    let fieldType = filterField.metaData.fieldType;
    let allowedValues = filterField.allowedValues;
    let field = renderField(filterField, null, editor, true, "", fieldMetadata);
    if (field.enumTypeName && allowedValues !== null) {
        field.allowedValues = allowedValues;
        //TODO:
        //GUIUtilities.emptyListBoxSelectionDeferred((MultiChoiceField<String>) field);
    }
    if (allowedValues !== null)//&& filterField instanceof CriteriaField)
    {
        //TODO: criteria filed
        // MultiChoiceField<String> multiChoiceField = (MultiChoiceField<String>) field;
        // multiChoiceField.getWidget().setMultipleSelect(true);
        // if (allowedValues.size() > MAX_VISIBLE_ALLOWEDVALUES)
        //     multiChoiceField.getWidget().setVisibleItemCount(MAX_VISIBLE_ALLOWEDVALUES);
        // else
        //     multiChoiceField.getWidget().setVisibleItemCount(allowedValues.size());
    }

    if (fieldType === FieldType.Reference) {
        let targetEnity = filterField.metaData.referencedEntityType;
        if (targetEnity.startsWith("$"))
            editor.registerDynamicSelector(field, targetEnity.substring(1));
    }
    if (fieldType === FieldType.EntityType) {
        //TODO:
        //addChangeHandlerToEntityType(filterField.getId(), editor, (MultiChoiceField) field);
    }
    if (field != null)
        field.usedInCriteria = true;
    return field;
}

function setSelectedIndices(targetWidget, inValues) {
    //TODO:
}

export function setRightHandSideValue(targetWidget, filterField, rightHandSideValue, inValues, presenter) {
    //TODO:
    if (filterField === null)
        return null;
    //TODO: instance of CriteriaField
    if (targetWidget.enumTypeName) //&& (filterField instanceof CriteriaField) &&filterField.hasAllowedValues())
    {
        if (rightHandSideValue && rightHandSideValue.length > 0 && inValues === null)
            inValues = rightHandSideValue;
        setSelectedIndices(targetWidget, inValues);
        return inValues;
    }
    // else if (targetWidget instanceof SelectorView)
    // {
    //     FlatObject flatObject = (FlatObject) FieldTypesUtils.parseString(rightHandSideValue, FieldType.Reference);
    //     ((SelectorViewImpl) targetWidget).setSelectedRef(flatObject);
    //     return flatObject;
    // }
    // else if (targetWidget instanceof GenericReferenceSelector)
    // {
    //     FlatObject flatObject = (FlatObject) FieldTypesUtils.parseString(rightHandSideValue, FieldType.Reference);
    //     ((GenericReferenceSelector) targetWidget).setValue(flatObject);
    //     targetWidget.bind();
    //     ((GenericReferenceSelector) targetWidget).getSelector().setSelectedRef(flatObject);
    //     return flatObject;
    // }
    else {
        //TODO:
        let fieldType_ = filterField.fieldType;
        if (!fieldType_)
            fieldType_ = filterField.metaData.fieldType;
        let parsedValue = parseString(rightHandSideValue, fieldType_);
        if (areEqual(parsedValue, CommonConstants.DEFAULT_VALUE_CURRENT_VIEW_NAME)) {
            if (presenter && presenter.viewName_)
                parsedValue = presenter.viewName_();
            else
                parsedValue = "";
        }
        targetWidget.setValue(parsedValue);
        return parsedValue;
    }
}

function parseString(value, type) {
    if (isNullOrUndefined(value))
        return null;
    if (type == null || type === FieldType.Text || type === FieldType.BigText || type === FieldType.EntityType
        || type === FieldType.Enum)
        return value;
    if (value === "")
        return null;
    if (type === FieldType.Integer || type === FieldType.Boolean
        || type === FieldType.Long || type === FieldType.Decimal) {
        return value;
    }
    if (type === FieldType.Date) {
        return deserializeDate(value);
    }
    if (type === FieldType.DateAndTime)
        return deserializeDateAndTime(value);
    if (type === FieldType.Time) {
        let date = new moment(value, Formats.DATE_MOMENT_FORMAT);
        let format = date.format(Formats.DATE_MOMENT_SERVER_FORMAT);
        return format;
    }

    if (type === FieldType.Reference || type === FieldType.Genericreference) {
        if (value === "$currentFiscalPeriod()" && fiscalPeriod)
            return fiscalPeriod;
        let parts = value.split(CommonConstants.FIELD_PARTS_SEP);
        return {
            id: parts.length > 0 ? parts[0] : "",
            entityType: parts.length > 1 ? parts[1] : "",
            code: parts.length > 2 ? parts[2] : "",
            altCode: parts.length > 3 ? parts[3] : "",
            name1: parts.length > 4 ? parts[4] : "",
            name2: parts.length > 5 ? parts[5] : "",
        };
    }
    return value;
}

function deserializeDateAndTime(value) {
    if (!value)
        return null;
    if (value.trim().equalsIgnoreCase(CommonConstants.DEFAULT_VALUE_NOW) || value.trim().equalsIgnoreCase(CommonConstants.DEFAULT_VALUE_TODAY))
        value = new Date();
    let date = new moment(value, Formats.DATE_MOMENT_FORMAT);
    let format = date.format(Formats.DATE_MOMENT_SERVER_FORMAT);
    return format;
}

function deserializeDate(value) {
    if (!value)
        return null;
    if (value.trim().equalsIgnoreCase(CommonConstants.DEFAULT_VALUE_NOW) || value.trim().equalsIgnoreCase(CommonConstants.DEFAULT_VALUE_TODAY))
        value = new Date();
    else if (value.trim().equalsIgnoreCase(CommonConstants.DEFAULT_VALUE_MONTH_START))
        value = getMonthStart(new Date());
    else if (value.trim().equalsIgnoreCase(CommonConstants.DEFAULT_VALUE_MONTH_END))
        value = getMonthEnd(new Date());
    else if (value.trim().equalsIgnoreCase(CommonConstants.DEFAULT_VALUE_YEAR_START))
        value = getYearStart(new Date());
    else if (value.trim().equalsIgnoreCase(CommonConstants.DEFAULT_VALUE_YEAR_END))
        value = getYearEnd(new Date());
    else if (value.trim().startsWith(CommonConstants.DEFAULT_VALUE_PLUS_DAYS))
        value = addPeriodToDate(new Date(), extractAddedValue(CommonConstants.DEFAULT_VALUE_PLUS_DAYS, value), 'day');
    else if (value.trim().startsWith(CommonConstants.DEFAULT_VALUE_PLUS_MONTHS))
        value = addPeriodToDate(new Date(), extractAddedValue(CommonConstants.DEFAULT_VALUE_PLUS_MONTHS, value), 'month');
    else if (value.trim().startsWith(CommonConstants.DEFAULT_VALUE_PLUS_YEARS))
        value = addPeriodToDate(new Date(), extractAddedValue(CommonConstants.DEFAULT_VALUE_PLUS_YEARS, value), 'year');
    else if (value.trim().startsWith(CommonConstants.DEFAULT_VALUE_PLUS_WEEKS))
        value = addPeriodToDate(new Date(), extractAddedValue(CommonConstants.DEFAULT_VALUE_PLUS_WEEKS, value), 'week');
    let date = new moment(value, Formats.DATE_MOMENT_FORMAT);
    let format = date.format(Formats.DATE_MOMENT_SERVER_FORMAT);
    return format;
}

/**
 *
 * @param date {Date}
 * @param toAdd {number}
 * @param period {string}
 */
function addPeriodToDate(date, toAdd, period) {
    let m = moment(date);
    m.add(toAdd, period);
    return m.toDate();
}

/***
 *
 * @param prefix {string}
 * @param value {string}
 * @return {number}
 */
function extractAddedValue(prefix, value) {
    return parseFloat(value.substring(prefix.length, value.lastIndexOf(')')));
}

export function getMonthStart(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function getMonthEnd(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

let staticYearStart, staticYearEnd;

export function setStaticYearStart(yStart) {
    if (yStart)
        staticYearStart = new Date(yStart);
    else
        staticYearStart = null;
}

export function setStaticYearEnd(yEnd) {
    if (yEnd)
        staticYearEnd = new Date(yEnd);
    else
        staticYearEnd = null;
}
export function getYearStart(date) {
    if (staticYearStart)
        return staticYearStart;
    return new Date(date.getFullYear(), 0, 1);
}

export function getYearEnd(date) {
    if (staticYearEnd)
        return staticYearEnd;
    return new Date(date.getFullYear(), 11, 31);
}